import { graphql } from "gql";

const EDIT_ME_MUTATION = graphql(`
  mutation EditMe($input: EditMeInput!) {
    editMe(input: $input) {
      ...User
    }
  }
`);

export default EDIT_ME_MUTATION;
